export const HISTORY_TRAVERSE_EVENT = "sw-history-traverse";
